<template>
  <path
    d="M19.1699 7C20.4457 7 21.4795 7.9873 21.4795 9.20508V19.4951C21.4794 20.7128 20.4456 21.7002 19.1699 21.7002H5.30957C4.03407 21.7 3.00013 20.7127 3 19.4951V9.20508C3 7.98744 4.03399 7.00022 5.30957 7H19.1699ZM9 12C8.44772 12 8 12.4477 8 13V16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16V13C10 12.4477 9.55228 12 9 12ZM15 12C14.4477 12 14 12.4477 14 13V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V13C16 12.4477 15.5523 12 15 12Z"
    fill="currentColor"
  />
  <path
    d="M23 13V16"
    stroke="#868D9C"
    stroke-width="2"
    stroke-linecap="round"
  />
  <path d="M1 13V16" stroke="#868D9C" stroke-width="2" stroke-linecap="round" />
  <path
    d="M12.5 4.5V4.5C12.5 3.56288 12.9683 2.68777 13.7481 2.16795L14 2"
    stroke="#868D9C"
    stroke-width="2"
    stroke-linecap="round"
  />
</template>
